const ALLOWED_TAGS = new Set([
  'a', 'b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'span',
  'div', 'table', 'thead', 'tbody', 'tr', 'td', 'th', 'hr',
  'pre', 'code', 'sub', 'sup', 'mark', 'small',
]);

const ALLOWED_ATTRS = new Set([
  'href', 'target', 'rel', 'class', 'id', 'title', 'alt',
  'colspan', 'rowspan',
]);

const SAFE_URL_PATTERN = /^(?:https?:\/\/|mailto:|tel:|#)/i;

function escapeHtml(text) {
  if (!text) return '';
  const str = String(text);
  const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;' };
  return str.replace(/[&<>"']/g, c => map[c]);
}

function sanitizeHtml(dirty) {
  if (!dirty) return '';

  const parser = new DOMParser();
  const doc = parser.parseFromString(dirty, 'text/html');
  const clean = _sanitizeNode(doc.body);
  const temp = document.createElement('div');
  while (clean.firstChild) {
    temp.appendChild(clean.firstChild);
  }
  return temp.innerHTML;
}

function _sanitizeNode(node) {
  const fragment = document.createDocumentFragment();

  for (const child of Array.from(node.childNodes)) {
    if (child.nodeType === Node.TEXT_NODE) {
      fragment.appendChild(document.createTextNode(child.textContent));
      continue;
    }

    if (child.nodeType !== Node.ELEMENT_NODE) continue;

    const tag = child.tagName.toLowerCase();

    if (!ALLOWED_TAGS.has(tag)) {
      const inner = _sanitizeNode(child);
      fragment.appendChild(inner);
      continue;
    }

    const el = document.createElement(tag);

    for (const attr of Array.from(child.attributes)) {
      const name = attr.name.toLowerCase();
      if (!ALLOWED_ATTRS.has(name)) continue;
      if (name.startsWith('on')) continue;

      let value = attr.value;
      if (name === 'href' && !SAFE_URL_PATTERN.test(value.trim())) continue;
      if (name === 'target') value = '_blank';

      el.setAttribute(name, value);
    }

    if (tag === 'a') {
      el.setAttribute('rel', 'noopener noreferrer');
    }

    const sanitizedChildren = _sanitizeNode(child);
    el.appendChild(sanitizedChildren);
    fragment.appendChild(el);
  }

  return fragment;
}

export { escapeHtml, sanitizeHtml };
